import React from 'react';
import {Link, NavLink} from 'react-router-dom'
import './MainNav.css';
import {getUserGroups} from '../helpers';
import logo from '../novi-isb-logo1.png'

class MainNav extends React.Component {
  constructor(props) {
    super(props);
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout(event) {
      window.localStorage.removeItem('token');
      this.props.setToken();
      event.preventDefault();
  }

  render() {
    let module = '';
    if (this.props.location) {
      switch (this.props.location.pathname.slice(-3)) {
        case "eal":
            module = 'eal';
            break;
        case "lrc":
            module = 'lrc';
            break;
        case "map":
            module = 'map';
            break;
        case "/es":
            module = 'es';
            break;
        case "ata":
            module = 'counselor-data';
            break;
        case "nts":
            if (this.props.location.pathname.slice(-8) === 'comments') { module = 'comments'; }
            if (this.props.location.pathname.slice(-9) === 'documents') { module = 'documents'; }
            break;
        case "ile":
            module = 'language-profile';
            break;
        case "sat":
            if (this.props.location.pathname.slice(-4) === 'psat') { module = 'psat'; }
            if (this.props.location.pathname.slice(-4) === '/sat') { module = 'sat'; }
            break;
        case "erb":
            module = 'erb';
            break;
        case "cem":
            module = 'cem';
            break;
        case "bdp":
            module = 'ibdp';
            break;
        case "ing":
            module = 'grading';
            break;
        default:
            module = '';
      }; 
    }
    const baseUri = this.props.studentId ? this.props.studentId + "/" : "";
    var handleCollapse = this.props.handleCollapse;
    var isCollapsed = this.props.isCollapsed.mainNav;
    return (
      <aside className={isCollapsed ? "MainNav is-collapsed" : "MainNav"}>
          <Link to="/dashboard">
            <div className="app-logo-container">
              {<img src={logo} className="app-logo" alt="logo" />}
            </div>
            {/*
            <h2>ISB Dashboard</h2>
            */}
          </Link>
          <ul>
            <li>
              <NavLink to="/dashboard">
                <span className="main-nav-icon"><i className="fa fa-dashboard"></i></span>
                <span className="main-nav-label">Dashboard</span>
              </NavLink>
            </li>

            <li>
              <NavLink exact to={module ? "/students/" + module : "/students"}>
                <span className="main-nav-icon"><i className="fa fa-users"></i></span>
                <span className="main-nav-label">Students</span>
              </NavLink>
            </li>

            <li>
              <NavLink exact to={"/grade-reports"}>
                <span className="main-nav-icon"><i className="fa fa-file-o"></i></span>
                <span className="main-nav-label">Grade Reports</span>
              </NavLink>
            </li>
          </ul>

            <ul className="MainNav--bottom">
              { getUserGroups().includes('admin') &&
                <li>
                  <NavLink to="/settings">
                    <span className="main-nav-icon"><i className="fa fa-cog"></i></span>
                    <span className="main-nav-label">Settings</span>
                  </NavLink>
                </li>
              }

              <li>
                <a className="user" >
                  <span className="main-nav-icon"><i className="fa fa-user-circle-o"></i></span>
                  <span className="main-nav-label">{this.props.user.cn}</span>
                </a>
              </li>

              <li>
                <a className="logout" onClick={this.handleLogout}>
                  <span className="main-nav-icon"><i className="fa fa-sign-out"></i></span>
                  <span className="main-nav-label">Logout</span>
                </a>
              </li>

              <li className="collapse-main-nav" onClick={handleCollapse}>
                <a>
                  <span className="main-nav-icon"><i className={isCollapsed ? "fa fa-caret-right" : "fa fa-caret-left"}></i></span>
                </a>
              </li>
            </ul>
      </aside>
    );
  }
}

export default MainNav;



// WEBPACK FOOTER //
// ./src/MainNav/MainNav.js